module.exports = __webpack_public_path__ + "img/4-2.1e9f6979.svg";